document.querySelectorAll('[data-page-index]').forEach((frame) => {
  const indexLinks = frame.querySelectorAll('.js-pageIndex')
  const sectionSelector = frame.dataset.pageIndexSection

  if (!indexLinks.length || !sectionSelector) {
    return
  }

  const sections = frame.querySelectorAll(sectionSelector)

  if (!sections.length) {
    return
  }

  const setActiveIndex = (id) => {
    indexLinks.forEach((link) => {
      link.classList.toggle('is-active', link.getAttribute('href') === `#${id}`)
    })
  }

  indexLinks.forEach((link) => {
    link.addEventListener('click', (event) => {
      const href = link.getAttribute('href')
      if (!href || !href.startsWith('#')) {
        return
      }

      const target = document.querySelector(href)
      if (!target) {
        return
      }

      event.preventDefault()
      target.scrollIntoView({ behavior: 'smooth', block: 'start' })
    })
  })

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setActiveIndex(entry.target.id)
        }
      })
    },
    {
      root: null,
      rootMargin: '-20% 0px -60% 0px',
      threshold: 0,
    },
  )

  sections.forEach((section) => observer.observe(section))
})
